<ng-container *ngIf="rate">
  <bar-rating
    style="color: goldenrod; background-color: goldenrod"
    [(rate)]="rate"
    [max]="5"
    [readOnly]="false"
  ></bar-rating>
</ng-container>
